"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccrualRateSchema = void 0;
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
const RATE_REQUIRED = "Please enter an annual rate";
const RATE_INVALID = "Annual rate must be a decimal fraction with at most six decimal places, e.g. 0.055";
const EFFECTIVE_DATE_REQUIRED = "Please enter the date the rate takes effect";
const EFFECTIVE_DATE_INVALID = "Effective date must be a calendar date in the format YYYY-MM-DD";
const UNKNOWN_FIELD = "Only annualRate and effectiveFrom can be set; the day-count basis is the fund's";
const RATE_PATTERN = /^(0|[1-9]\d*)(\.\d{1,6})?$/;
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
// The pattern alone accepts 2026-02-30; a round trip through UTC rejects any day the month lacks.
const isCalendarDate = (value) => {
    const match = ISO_DATE_PATTERN.exec(value);
    if (!match) {
        return false;
    }
    const [, year, month, day] = match.map(Number);
    const parsed = new Date(Date.UTC(year, month - 1, day));
    return parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day;
};
// Strict, because yup otherwise strips unknown keys silently: a `dayCountBasis` must be refused.
exports.AccrualRateSchema = yup
    .object({
    annualRate: yup
        .string()
        .required(RATE_REQUIRED)
        .matches(RATE_PATTERN, RATE_INVALID)
        .test("ceiling", ({ value }) => (0, constants_1.accrualRateAboveCeiling)(String(value)), (value) => value === undefined || !RATE_PATTERN.test(value) || Number(value) <= constants_1.ACCRUAL_MAX_ANNUAL_RATE)
        .label("Annual rate"),
    effectiveFrom: yup
        .string()
        .required(EFFECTIVE_DATE_REQUIRED)
        .test("calendarDate", EFFECTIVE_DATE_INVALID, (value) => value === undefined || isCalendarDate(value))
        .label("Effective date"),
})
    .noUnknown(true, UNKNOWN_FIELD)
    .strict();
//# sourceMappingURL=AccrualRateSchema.js.map